import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/icons/bone_close.svg")